import { AxiosInstance } from 'axios'

import { apiPaths } from '@percent/cause-dashboard/services/apiPaths'
import { PBPResponse } from '@percent/cause-dashboard/services/types/pbpResponses.types'

import type { RecordProductActivationSurveyResponseBody, SurveyProductDetail } from './surveyService.types'

type SurveyServiceCapabilities = {
  percentClient: AxiosInstance
}

export const surveyService = ({ percentClient }: SurveyServiceCapabilities) => ({
  getSurvey: (token: string): Promise<{ data: PBPResponse<{ products: SurveyProductDetail[] }> }> =>
    percentClient.get<PBPResponse<{ products: SurveyProductDetail[] }>>(`${apiPaths.v1StoreSurveys}/${token}`),

  submitSurveyResponses: (token: string, body: RecordProductActivationSurveyResponseBody) =>
    percentClient.post(`${apiPaths.v1StoreSurveys}/${token}`, body)
})
